import {
  Routes_DE as Routes,
  Routes_DE,
  Routes_EN,
} from '@allesauto/utils/routes';
import { useRouter } from 'next/router';
import { ParsedUrlQuery } from 'querystring';
import { createContext, useContext, useEffect, useState } from 'react';

export const RouterHistoryContext = createContext<string | null>(null);

// set the selected filters in local storage
const setFiltersInLocalStorage = (filters: ParsedUrlQuery) => {
  localStorage.setItem('selectedFilters', JSON.stringify(filters));
};

// get the selected filters from local storage
export const getFiltersFromLocalStorage = () => {
  const filtersString = localStorage.getItem('selectedFilters');
  return filtersString ? JSON.parse(filtersString) : null;
};

export const useRouterHistoryContext = () => {
  const previousRoute = useContext(RouterHistoryContext);

  return previousRoute;
};

export const useRouterHistory = () => {
  const router = useRouter();
  const [previousRoute, setPreviousRoute] = useState<string | null>(null);

  useEffect(() => {
    function handleBeforeHistoryChange() {
      const skipRoutes: string[] = [
        Routes.ERROR,
        Routes.ACCOUNT.LOGIN,
        Routes.ACCOUNT.REGISTER,
        Routes.ACCOUNT.CONFIRM,
        Routes.ACCOUNT.PASSWORD,
      ];

      if (!skipRoutes.includes(router.pathname)) {
        setPreviousRoute(router.asPath);
      }

      if (
        router.asPath.startsWith(Routes_DE.CARS.ALL) ||
        router.asPath.startsWith(Routes_EN.CARS.ALL) ||
        router.asPath.startsWith(Routes_DE.PCP_ACCESSORIES) ||
        router.asPath.startsWith(Routes_EN.PCP_ACCESSORIES)
      ) {
        const query = router.query;

        if (query && typeof query === 'object') {
          setFiltersInLocalStorage(query);
        }
      }
    }

    router.events.on('beforeHistoryChange', handleBeforeHistoryChange);

    return () => {
      router.events.off('beforeHistoryChange', handleBeforeHistoryChange);
    };
  }, [router]);

  return previousRoute;
};
